import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { MissionsService } from 'src/app/services/missions.service';
import { AlertController } from '@ionic/angular';
import { ToolsService } from 'src/app/services/tools.service';
import { AuthService } from 'src/app/services/auth.service';
import { IAFiles } from 'src/app/interfaces/iafiles.interface';
import { ConfigService } from 'src/app/services/config.service';
import { ModalAdditionalQuestionsPage } from '../modal-additional-questions/modal-additional-questions.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ModalIaResultsResumePage } from '../modal-ia-results-resume/modal-ia-results-resume.page';
import { ModalIaActivityDescriptionPage } from '../modal-ia-activity-description/modal-ia-activity-description.page';
import { ModalIaNotApprovedRulesPage } from '../modal-ia-not-approved-rules/modal-ia-not-approved-rules.page';
declare let chrome: any; // Declare chrome for TypeScript

@Component({
  selector: 'app-modal-ia-module',
  templateUrl: './modal-ia-module.page.html',
  styleUrls: ['./modal-ia-module.page.scss'],
})
export class ModalIaModulePage implements OnInit {

  // Variables
  steps = 0; //
  ia_activities: any[] = []; // array of activities
  private readonly MAX_FILE_SIZE_BYTES = 3 * 1024 * 1024;
  fileType: 'image' | 'pdf';
  base64String: string = ''; // base64 string
  resultIa: any; // result of IA activity
  template: any; // selected template  
  processingStep = 0; // current processing step
  isProcessing = false; // flag to indicate if processing is in progress
  resultReady = false; // flag to indicate if result is ready
  progressValue = 0; // progress value for loading animation
  selectedActivities: any[] = []; // array to store selected activities
  ia_result: any[] = []; // result of IA activity
  token: any; // token for IA activity
  pk: any; // primary key for IA activity
  seeFile: boolean = false;
  isLoading: boolean = true; // flag to indicate if loading is in progress
  showDelayMessage = false; // flag to show delay message
  playerData: any;
  // Show 1 slide at a time, with pagination enabled, also show arrows and autoplay
  sliderOptions = { slidesPerView: 1, pagination: { clickable: true }, navigation: true, autoplay: true, loop: true };
  uploadCountKey: string;
  loadingMessage = '0';
  progressPercent = 0;
  totalSteps = 0;
  currentStep = 0;
  IAFiles: IAFiles // Interface for IA files
  uploadFiles: any[] = []; // Array to store uploaded files when allowing multiple files
  seeResults: boolean = false;
  reasons: any[] = [];
  referrals_info: any;
  markAllActivities: boolean = false;
  selectedActivitiesCheckpoint: any;
  originalFile: any;
  storageKey: any;
  requestId: any;

  constructor(private modalController: ModalController, private missionsService: MissionsService, navParams: NavParams, private alertController: AlertController
    , private toolsService: ToolsService, private authService: AuthService, private analyticsService: AnalyticsService, public configService: ConfigService
  ) {
    this.template = navParams.get('template');
    this.seeFile = navParams.get('seeFiles');
    this.playerData = navParams.get('playerData');
    this.ia_activities = this.template.ia_activity;
    this.uploadCountKey = `ia_upload_count_${this.template.id}`;
    this.getReferralsInfo();
    this.updatePlayerRanking();
  }

  ngOnInit() {
    this.ia_activities = this.ia_activities.map(activity => {
      const isChecked = this.ia_activities.length === 1 ? true : false;
      const updatedActivity = { ...activity, checked: isChecked };

      if (isChecked) {
        this.selectedActivities.push(updatedActivity);
        this.markAllActivities = true
      }

      return updatedActivity;
    });

    // use this to debug the this.selectedActivities array
    // console.log("selected activities onInit", this.selectedActivities)
    this.analyticsService.AnalyticsServiceModalView('IA Modal - ' + this.template.name);
    this.ia_result.forEach(r => r.showReason = false);
    const count = Number(localStorage.getItem(this.uploadCountKey) || '0');
    if (count >= this.template.settings[0].max_show_instructions) {
      this.steps = 1;
    }
    if (this.seeFile) {
      this.isLoading = true;
      this.missionsService.get_results().then((response: any) => {
        this.resultIa = response;
        // console.log("ResultIA ", this.resultIa);
        this.isLoading = false;
      }).catch(error => {
        this.isLoading = false;
      });
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;
    if (!this.isFileSizeValid(file)) {
      event.target.value = '';
      return;
    }
    this.originalFile = file
    if (file.type.startsWith("image/") || file.type == "application/pdf") {
      const reader = new FileReader();
      reader.onload = () => {
        this.fileType = file.type.startsWith("image/") ? 'image' : 'pdf';
        this.base64String = reader.result as string
        this.processImage();
      }
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
      };
      reader.readAsDataURL(file);
    } else {
      console.error("Invalid file type. Please select an image or PDF.");
    }
  }

  reset() {
    this.steps = 0;
    this.processingStep = 0;
    this.isProcessing = false;
    this.resultReady = false;
  }

  //Function to process image (Loading)
  processImage() {
    this.selectedActivitiesCheckpoint = this.selectedActivities
    this.incrementUploadCount();
    this.steps = 2;
    this.isProcessing = true;
    this.processingStep = 1;
    this.progressValue = 0.2;
    this.showDelayMessage = false;
    this.totalSteps = this.ia_activities.length + 3;
    this.currentStep = 0;
    this.updateProgress('Iniciando proceso...', 10);

    const startTime = Date.now();
    const progressInterval = setInterval(() => {
      if (this.progressValue < 0.8) {
        this.progressValue += 0.005;
      }
    }, 200);


    const delayTimeout = setTimeout(() => {
      this.showDelayMessage = true;
    }, 40000);

    let response =

      // this.missionsService.generateToken(this.template.id).then((response: any) => {
      this.missionsService.generateTokenSaveFileV2(this.template.id, this.base64String).then((response: any) => {
        const elapsed = Date.now() - startTime;
        this.currentStep++;
        // this.token = response;
        this.storageKey=response.result.storage_key
        this.requestId=response.result.request_id
        this.updateProgress('Subiendo archivo...', 30);
        // if (this.token.token == null) {
        if (this.requestId == null || this.storageKey == null) {
          this.toolsService.showErrorToast('Error en el procesamiento de IA, intentalo de nuevo mas tarde');
          this.steps = 1;
          this.isProcessing = false;
          clearTimeout(delayTimeout);
          clearInterval(progressInterval);
          return;
        }
        clearInterval(progressInterval);
        this.progressValue = 0.7;
        this.processingStep = 3;
        this.iaProcess().then(() => {
          setTimeout(() => {
            if (this.ia_result.some(result => result.result.final_state === 'REJECTED')) {
              this.steps = 3;
            }
            this.progressValue = 1;
            this.currentStep = this.totalSteps;
            this.updateProgress(null, 49);
            this.isProcessing = false;
            this.resultReady = true;
            clearTimeout(delayTimeout);
          }, 1000);
        });
      }, error => {
        clearTimeout(delayTimeout);
        clearInterval(progressInterval);
        this.isProcessing = false;
        this.steps = 1;
      });
  }


  // Function to handle activity selection 
  onActivitySelect(id: number, state: string): void {
    const index = this.selectedActivities.findIndex(activity => activity.id === id);
    if (index === -1) {
      this.selectedActivities.push({ id, state });
      this.validateRules();
    } else {
      this.selectedActivities.splice(index, 1);
    }
  }

  isSelected(id: number): boolean {
    return this.selectedActivities.some(activity => activity.id === id);
  }

  private setDefaultSelections() {
    this.selectedActivities = this.ia_result
      .filter(res => res.result.final_state !== 'REJECTED')
      .map(res => ({ id: res.activity.id, state: res.result.final_state }));
  }


  async validatedocumentDuratex() {
    const alert = await this.alertController.create({
      header: 'Validar documento',
      message: 'Por favor ingresa el documento del carpintero:',
      inputs: [
        {
          name: 'cedula',
          type: 'text',
          placeholder: 'Documento'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Continuar',
          handler: (data) => {
            const cedula = data.cedula;
            if (!cedula) {
              this.alertController.create({
                header: 'Error',
                message: 'Debe ingresar una cédula válida.',
                buttons: ['OK']
              }).then(errorAlert => errorAlert.present());
              return false;
            }
            this.toolsService.showLoader('Validando documento...');
            this.missionsService.validatedocumentDuratex(cedula).then((response: any) => {
              this.toolsService.dismissLoader();
              if (response.is_carpenter === true) {
                this.alertController.create({
                  header: 'Documento válido',
                  message: 'El documento pertenece a un carpintero registrado.',
                  buttons: ['OK']
                }).then(successAlert => successAlert.present());
              } else {
                this.alertController.create({
                  header: 'Carpintero no registrado',
                  message: '👉 Invítalo a inscribirse en el siguiente enlace para que puedas subir facturas y ganar ' + this.configService.company_info.points_name + '.<br><br>📲 ' + this.configService.company_info.variants[0].domain + '/autenticacion?referral=' + this.referrals_info.referral_code,
                  buttons: [
                    {
                      text: 'Copiar enlace',
                      handler: () => {
                        try {
                          chrome.windows.create({ "url": this.configService.company_info.variants[0].domain + '/autenticacion?referral=' + this.referrals_info.referral_code, "incognito": true });
                        } catch (error) {
                          console.debug('Error opening link in incognito mode:', error);
                        }
                        // window.open('https://club.duratex.com.co', '_blank');
                        navigator.clipboard.writeText(this.configService.company_info.variants[0].domain + '/autenticacion?referral=' + this.referrals_info.referral_code);
                        this.toolsService.showSuccessToast('Enlace copiado al portapapeles.');
                        return false;
                      }
                    },

                    'OK']

                }).then(errorAlert => errorAlert.present());
              }

            }).catch(() => {
              this.toolsService.dismissLoader();
              this.alertController.create({
                header: 'Error',
                message: 'Ocurrió un error al validar el documento.',
                buttons: ['OK']
              }).then(errorAlert => errorAlert.present());
            });

            return true;
          }
        }
      ]
    });
    await alert.present();
  }

  validateRules() {
    for (let i = 0; i < this.selectedActivities.length; i++) {
      const activityId = this.selectedActivities[i];
      const activity = this.ia_activities.find((activity) => activity.id === activityId);
    }
  }

  //Function to 
  async iaProcess() {
    this.isLoading = true;
    this.loadingMessage = 'Subiendo archivo...';
    try {
      if (this.base64String.startsWith("data:image/")) await this.missionsService.externalProcessV2(this.storageKey, this.requestId);
      else await this.missionsService.externalProcessV2(this.storageKey, this.requestId);
    } catch (error) {
      console.error('Error during external process:', error);
      this.analyticsService.AnalyticsServiceError('ia-upload', error.message);
      return this.manageIaError(1);
    }
    this.currentStep++;
    this.updateProgress('Leyendo información del archivo...', 49);
    const waitStart = Date.now();
    const waitInterval = setInterval(() => {
      const seconds = (Date.now() - waitStart) / 1000;
      if (seconds > 14) {
        this.loadingMessage = 'Estamos tardando más de lo normal...';
      } else if (seconds > 8) {
        this.loadingMessage = 'Estamos validando tu archivo...';
      }
    }, 1000);
    try {
      await this.missionsService.waitForResponseV2(this.requestId);
    } catch (error) {
      clearInterval(waitInterval);

      console.error('Error waiting for IA response:', error);
      // Convert error to string if it's not
      let errorMessage = '';
      if (typeof error === 'string') {
        errorMessage = error;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      } else {
        errorMessage = JSON.stringify(error);
      }
      this.analyticsService.AnalyticsServiceError('ia-wait-response', errorMessage);
      return this.manageIaError(2);
    }
    clearInterval(waitInterval);
    this.currentStep++;
    let results = [];
    let index = 0;
    this.updateProgress(null, 95);
    // for (let activity of this.ia_activities) {
    for (let activity of this.selectedActivities) {
      index++;
      // Show loading message for each activity if there are more than one
      if (this.selectedActivities.length > 1) this.loadingMessage = `Comprobando reglas de las actividades (${index}/${this.selectedActivities.length})`;
      else this.loadingMessage = 'Comprobando reglas de la actividad';
      this.progressPercent = Math.round(((this.currentStep + index - 1) / this.totalSteps) * 100);
      let response;
      try {
        response = await this.missionsService.resultIaActivity(activity.id, this.requestId, this.base64String);
      } catch (error) {
        console.error('Error getting IA result for activity', activity.id, error);
        this.analyticsService.AnalyticsServiceError('ia-get-result', error.message);
        return this.manageIaError(3);
      }
      results.push({
        activity: activity,
        result: response
      });
    }
    this.currentStep += this.selectedActivities.length;
    this.updateProgress();
    console.debug('Results from IA:', results);
    this.ia_result = results;
    this.setDefaultSelections();
    this.validateRules();
    const notRejected = results.every(result => result.result.final_state === 'APPROVED' || result.result.final_state === 'MANUAL_VALIDATION')
    if (notRejected) {
      this.showResult(this.ia_result)
    }
  }

  manageIaError(errorCode, errorMessage?: any) {
    this.steps = 0;
    this.isLoading = false;
    this.closeModal();
    if (!errorMessage || errorMessage == '') errorMessage = 'Error al validar el archivo, por favor, inténtalo nuevamente. Si el error persiste, contacta a soporte.';
    this.toolsService.showErrorToast(`[${errorCode}] ` + errorMessage);
  }


  async save() {
    this.steps = 4;
    this.isLoading = true;

    const activities = Array.isArray(this.selectedActivities) ? this.selectedActivities : [];
    if (activities.length === 0) {
      this.loadingMessage = 'No hay actividades por guardar.';
      this.isLoading = false;
      return;
    }

    try {
      for (let i = 0; i < activities.length; i++) {
        const activity = activities[i];
        const current = i + 1;
        this.loadingMessage = this.buildSavingMessage(current, activities.length);

        if (Array.isArray(activity.additional_answers) && activity.additional_answers.length > 0) {
          for (const answer of activity.additional_answers) {
            if (answer) {
              await this.missionsService.saveResponseV2(activity.id, this.base64String, this.requestId, activity.state, answer.answers_to_save);
            }
          }
        } else {
          await this.missionsService.saveResponseV2(activity.id, this.base64String, this.requestId, activity.state);
        }
      }
      this.isLoading = false;
    } catch (error) {
      console.error('Error while saving IA responses:', error);
      this.toolsService.showErrorToast('Error al guardar la información, por favor intenta nuevamente.');
      this.steps = 1;
      this.isLoading = false;
    }
  }



  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }

  goBack() {
    this.uploadFiles = []
    this.steps = 1
    this.ia_result = []
    this.selectedActivities = this.selectedActivitiesCheckpoint
  }

  goFirstStep() {
    this.steps = 1;
    // this.selectedActivities = [];
    this.ia_result = [];
    this.base64String = '';
  }

  activeReason: any = null;

  async openReason(result: any) {
    this.activeReason = result;
    const modal = await this.modalController.create({
      component: ModalIaNotApprovedRulesPage,
      cssClass: 'ia-not-approved-rules-modal',
      componentProps: {
        activeReason: this.activeReason
      }
    });
    return await modal.present();
  }

  updateProgressPercentage(maxValue?: number) {
    const currentTimer = setInterval(() => {
      if (this.progressPercent < maxValue) {
        // Increment the progress percentage in random intervals
        this.progressPercent += Math.floor(Math.random() * 2) + 0; // Increment by 0 to 2
      } else {
        clearInterval(currentTimer);
      }
    }, 600);
  }

  private updateProgress(message?: string, maxValue?: number) {
    if (message !== undefined) {
      this.loadingMessage = message;
    }
    if (this.totalSteps > 0) {
      this.progressPercent = Math.round((this.currentStep / this.totalSteps) * 100);
    } else {
      this.progressPercent = 0;
    }
    if (maxValue) this.updateProgressPercentage(maxValue);
  }

  incrementUploadCount() {
    const current = Number(localStorage.getItem(this.uploadCountKey) || '0');
    localStorage.setItem(this.uploadCountKey, String(current + 1));
  }

  getStateLabel(state: string): string {
    switch (state) {
      case 'APPROVED':
        return 'APROBADA';
      case 'REJECTED':
        return 'NO APROBADA';
      case 'MANUAL_VALIDATION':
        return 'EN VALIDACIÓN';
      default:
        return state;
    }
  }



  private buildSavingMessage(current: number, total: number): string {
    return `Guardando información (${current}/${total})...`;
  }

  private hasAdditionalQuestions(activity: any): boolean {
    return (
      activity &&
      activity.additional_questions != null &&
      (
        (Array.isArray(activity.additional_questions) && activity.additional_questions.length > 0) ||
        (typeof activity.additional_questions === 'object' && Object.keys(activity.additional_questions).length > 0)
      )
    );
  }

  private normalizeAdditionalAnswers(additionalAnswers: any): any[] {
    if (!additionalAnswers) {
      return [];
    }

    if (Array.isArray(additionalAnswers)) {
      return additionalAnswers.reduce((acc: any[], current: any) => acc.concat(this.normalizeAdditionalAnswers(current)), []);
    }

    return [additionalAnswers];
  }

  private findAdditionalAnswer(item: any, activityId: number): any | null {
    const answers = this.normalizeAdditionalAnswers(item && item.additional_answers ? item.additional_answers : null);
    return answers.find(answer => answer && answer.activity_id === activityId) || null;
  }



  get hasNonRejectedActivities(): boolean {
    return this.ia_result.some(result =>
      result.result.final_state === 'APPROVED' ||
      result.result.final_state === 'MANUAL_VALIDATION'
    );
  }

  /** When allowing multiple files, this function will handle the file selection
   * Function to handle file selection
   * @param event 
   */
  async onFilesSelected(event: any) {
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isFileSizeValid(file)) {
        continue;
      }
      const base64 = await this.convertToBase64(file);
      const newFile: IAFiles = {
        id: Math.floor(Math.random() * 100000),
        name: file.name,
        file: base64,
        loading: true,
        state: 'pending',
        reject_reasons: null,
        fileType: file.type.startsWith("image/") ? 'image' : 'pdf',
        pk: null
      }
      if (this.selectedActivities.length > 1) {

        this.uploadFiles.push(newFile);
        console.log("New file added:", this.uploadFiles);
        this.uploadProcess(newFile, file);
      } else if (this.selectedActivities.length === 1) {  // 1 activity, so we can process the file immediately
        this.uploadFiles.push(newFile);
        console.log("New file added:", this.uploadFiles, file);
        this.uploadProcess(newFile, file);
      }
    }
    event.target.value = '';
  }

  /**
   * Convert a file to base64 string.
   * @param file 
   */
  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // base64 con prefijo tipo: data:image/png;base64,...
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  /**
   * Generate token
   */
  async generateToken(file?): Promise<any> {
    try {
      const response: any = await this.missionsService.generateTokenSaveFileV2(this.template.id, this.base64String || file);
      if (response.result.storage_key && response.result.request_id) {
        return response.result;
      } else {
        throw new Error('Token no válido');
      }
    } catch (error) {
      console.error('Error generating token:', error);
      throw error;
    }
  }

  waitSeconds(seconds: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
  }

  private isFileSizeValid(file: File): boolean {
    if (file.size > this.MAX_FILE_SIZE_BYTES) {
      this.toolsService.showErrorToast('El archivo supera el tamaño máximo permitido de 3MB.');
      return false;
    }
    return true;
  }

  /**
   *  Upload process for a file.
   * @param file 
   */
  async uploadProcess(file: IAFiles, originalFile?: File | null) {
    this.steps = 2;
    file.state = 'uploading';
    file.progress = 10;
    file.loading = true;
    this.loadingMessage = 'Subiendo archivo';
    try {
      await this.simulateProgress(file, 10, 30);
      const tokenData = await this.generateToken(file.file);
      const requestId = tokenData.request_id;
      const storageKey = tokenData.storage_key;
      await this.simulateProgress(file, 30, 50);
      file.pk = requestId;
      this.uploadFiles.push(file)
      this.uploadFiles = this.uploadFiles.filter(file => file.pk != null);
      const map = new Map();
      this.uploadFiles.forEach(file => map.set(file.pk, file));
      this.uploadFiles = Array.from(map.values());
      let pk: any = null;
      if (file.fileType === 'pdf') await this.missionsService.externalProcessV2(storageKey, requestId);
      else await this.missionsService.externalProcessV2(storageKey, requestId);
      this.loadingMessage = 'Procesando IA';

      // if (this.ia_activities.length === 1) {
      if (this.selectedActivities.length === 1) {
        this.loadingMessage = 'Comprobando reglas de la actividad';
        await this.simulateProgress(file, 50, 80);
        await this.missionsService.waitForResponseV2(requestId);
        // const response: any = await this.missionsService.resultIaActivity(this.ia_activities[0].id, pk.pk);
        let response: any = null;
        for (let activity of this.selectedActivities) {
          response = await this.missionsService.resultIaActivity(activity.id, requestId, file.file);
        }

        await this.simulateProgress(file, 80, 100);
        file.state = 'success';
        file.loading = false;

        if (response.final_state === 'APPROVED') {
          file.result_status = 'APPROVED';
          file.reject_reasons = ["No hay reglas no cumplidas"];
        } else if (response.final_state === 'MANUAL_VALIDATION') {
          file.result_status = 'MANUAL_VALIDATION';
        } else {
          file.result_status = 'REJECTED';
          file.reject_reasons = response.failed_rules;
        }
      // } else if (this.ia_activities.length > 1) {
      } else if (this.selectedActivities.length > 1) {
        this.loadingMessage = 'Comprobando reglas de la actividad';
        await this.simulateProgress(file, 50, 80);
        await this.missionsService.waitForResponseV2(requestId);
        // const response: any = await this.missionsService.resultIaActivity(this.ia_activities[0].id, pk.pk);
        let response: any = null;
        for (let activity of this.selectedActivities) {
          response = await this.missionsService.resultIaActivity(activity.id, requestId, file.file);
        }

        await this.simulateProgress(file, 80, 100);
        file.state = 'success';
        file.loading = false;

        if (response.final_state === 'APPROVED') {
          file.result_status = 'APPROVED';
          file.reject_reasons = ["No hay reglas no cumplidas"];
        } else if (response.final_state === 'MANUAL_VALIDATION') {
          file.result_status = 'MANUAL_VALIDATION';
        } else {
          file.result_status = 'REJECTED';
          file.reject_reasons = response.failed_rules;
        }

      }
    } catch (error) {
      this.analyticsService.AnalyticsServiceError('ia-upload-multiple', error.message);
      console.error('Error uploading file:', error);
      file.state = 'error';
      file.loading = false;
      file.result_status = 'REJECTED';
      file.progress = 100;
    }
  }

  /**
   * Simulate file upload progress.
   */
  private async simulateProgress(file: IAFiles, from: number, to: number, duration = 1000) {
    const steps = 10;
    const increment = (to - from) / steps;
    const delay = duration / steps;

    for (let i = 1; i <= steps; i++) {
      file.progress = Math.round(from + increment * i);
      await this.sleep(delay);
    }
  }

  /**
   * Pause for a specified amount of time.
   */
  private sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * Get the status message based on the file state and result status.
   * @param item 
   */
  getStatusMessage(item: IAFiles): string {

    if (item.state === 'success') {
      if (item.result_status === 'APPROVED') return 'Aprobada';
      if (item.result_status === 'REJECTED') return 'No aprobada';
      if (item.result_status === 'MANUAL_VALIDATION') return 'Pendiente de validación';
    }
    if (item.state === 'error') return 'Error durante la carga';
    return '';
  }

  /**
   * Open the image in a new window
   * @param file 
   */
  viewImage(file: IAFiles) {
    if (typeof file.file === 'string' && file.file.startsWith('data:image')) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<img src="${file.file}" style="max-width: 100%; height: auto;" />`);
      } else {
        alert('No se pudo abrir la vista previa. Desactiva el bloqueador de ventanas emergentes.');
      }
    } else if (file.file.startsWith('data:application/pdf')) {
      const base64String = file.file.split(',')[1];

      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, '_blank');
    } else {
      console.warn('Archivo no compatible para vista previa:', file);
    }
  }



  /**
   * Get the icon corresponding to the result status.
   * @param status 
   */
  getResultIcon(status: string): string {
    switch (status) {
      case 'APPROVED':
        return 'checkmark-circle';
      case 'REJECTED':
        return 'close-circle';
      case 'MANUAL_VALIDATION':
        return 'help-circle';
      default:
        return 'alert-circle';
    }
  }

  /**
   * Get the color corresponding to the result status.
   * @param status 
   */
  getResultColor(status: string): 'success' | 'danger' | 'warning' | 'medium' {
    switch (status) {
      case 'APPROVED':
        return 'success';
      case 'REJECTED':
        return 'danger';
      case 'MANUAL_VALIDATION':
        return 'warning';
      default:
        return 'medium';
    }
  }

  /**
   * Get the hex color corresponding to the result status.
   * @param status 
   */
  getResultColorHex(status: string): string {
    switch (status) {
      case 'APPROVED':
        return '#2dd36f';
      case 'REJECTED':
        return '#eb445a';
      case 'MANUAL_VALIDATION':
        return '#ffc409';
      default:
        return '#666666';
    }
  }

  /**
   * Acepts an invoice and sends it to the server.
   * @param item 
   */
  async acceptInvoice(item: any) {
    const activities = Array.isArray(this.selectedActivities) ? this.selectedActivities : [];
    if (activities.length === 0) {
      this.toolsService.showErrorToast('No hay actividades por guardar.');
      item.state = 'error';
      return;
    }

    // const pk = item && item.pk ? item.pk : this.pk;
    if (!item) {
      this.toolsService.showErrorToast('No se encontró información para guardar.');
      item.state = 'error';
      return;
    }

    item.state = 'sending';

    try {
      for (let i = 0; i < activities.length; i++) {
        const activity = activities[i];
        this.loadingMessage = this.buildSavingMessage(i + 1, activities.length);
        const needsAdditionalAnswers = this.hasAdditionalQuestions(activity);

        if (needsAdditionalAnswers) {
          const additionalAnswer = this.findAdditionalAnswer(item, activity.id);
          if (additionalAnswer && additionalAnswer.answers_to_save) {
            await this.missionsService.saveResponseV2(activity.id, item.file, item.pk, item.result_status, additionalAnswer.answers_to_save);
            continue;
          }
        }

        await this.missionsService.saveResponseV2(activity.id, item.file, item.pk, item.result_status);
      }

      item.state = 'send';
      setTimeout(() => {
        this.removeFromQueue(item);
      }, 2000);
    } catch (error) {
      console.error('Error while saving IA responses for invoice:', error);
      item.state = 'error';
      this.toolsService.showErrorToast('Error al guardar la información, por favor intenta nuevamente.');
    }
  }

  /**
   * Deletes an item from the upload queue.
   * @param item 
   */
  removeFromQueue(item: any) {
    this.uploadFiles = this.uploadFiles.filter(i => i.id !== item.id);
    if (this.uploadFiles.length === 0) {
      this.steps = 1;
    }
  }

  /**
   * Send all files (APPROVED and MANUAL_VALIDATION).
   */
  async sendAllFiles() {
    if (this.uploadFiles.length === 0) return;

    const validItems = this.uploadFiles.filter(
      item => item.result_status === 'APPROVED' || item.result_status === 'MANUAL_VALIDATION' && item.pk
    );

    if (validItems.length === 0) {
      this.toolsService.showErrorToast('No hay facturas para enviar.');
      return;
    }

    if (validItems.length > 0) {
      await this.showQuestionsMultipleResults(validItems)
    }
  }

  /**
   * View the reject reasons.
   * @param item 
   */
  viewRejectReasons(item: IAFiles) {
    this.reasons = item.reject_reasons;
    this.seeResults = true;
  }

  showLegend = true;
  selectedActivity: any = null;
  show_rules_invalid: boolean = false;

  /**
   * Select an activity
   * @param activity 
   */
  async selectActivity(activity: any, event: any) {
    event.stopPropagation();
    const modal = await this.modalController.create({
      component: ModalIaActivityDescriptionPage,
      cssClass: 'ia-activity-details-modal',
      componentProps: {
        iaActivity: activity
      }
    })
    await modal.present();
  }

  async getReferralsInfo() {
    const response = await this.missionsService.getReferralsInfo();

    const key = Object.keys(response).find(k => Array.isArray(response[k]));

    response[key].sort((a, b) => {
      return new Date(b.date_joined).getTime() - new Date(a.date_joined).getTime();
    });

    response[key].forEach(item => {
      item.date_joined = this.toolsService.formatDate(item.date_joined);
    });

    this.referrals_info = response;
  }

  async updatePlayerRanking() {
    return await this.missionsService.getRankingByActivity();
  }

  async showResult(ia_results) {
    const listActivities: any[] = []

    for (const result of ia_results) {
      if (
        this.playerData && this.playerData.level && this.playerData.level.name === 'Carpintero' &&
        result.result.final_state === 'APPROVED' &&
        result.activity.additional_questions != null &&
        (
          (Array.isArray(result.activity.additional_questions) && result.activity.additional_questions.length > 0) ||
          (typeof result.activity.additional_questions === 'object' && Object.keys(result.activity.additional_questions).length > 0)
        )
      ) {
        listActivities.push(result.activity);
      }
    }

    if (listActivities.length === 0) {
      await this.save()
    } else {
      const modal = await this.modalController.create({
        component: ModalAdditionalQuestionsPage,
        cssClass: 'additional-questions-modal',
        componentProps: {
          listActivities: listActivities
        }
      });

      await modal.present();

      const { data } = await modal.onWillDismiss();

      for (let answers of data) {
        this.selectedActivities.forEach(activity => {
          if (answers.activity_id === activity.id) {
            activity.additional_answers = [answers]
          }
        })
      }

      await this.save();
    }
  }

  async showQuestionsByResult(item: any | null = null) {
    const listActivities: any[] = []

    for (let activity of this.selectedActivities) {
      if (
        item.result_status === 'APPROVED' &&
        this.playerData.level && this.playerData.level.name === 'Carpintero' &&
        activity.additional_questions != null &&
        (
          (Array.isArray(activity.additional_questions) && activity.additional_questions.length > 0) ||
          (typeof activity.additional_questions === 'object' && Object.keys(activity.additional_questions).length > 0)
        )
      ) {
        listActivities.push(activity);
      }
    }

    if (listActivities.length === 0) {
      await this.acceptInvoice(item)
    } else {
      const modal = await this.modalController.create({
        component: ModalAdditionalQuestionsPage,
        cssClass: 'additional-questions-modal',
        componentProps: {
          listActivities: listActivities
        }
      });

      await modal.present();

      const { data } = await modal.onWillDismiss();

      item.additional_answers = data

      await this.acceptInvoice(item)
    }
  }

  async showQuestionsMultipleResults(items: any[] = []) {
    const listActivities: any[] = [];

    for (let activity of this.selectedActivities) {
      const hasApprovedItem = items.some(item =>
        item.result_status === 'APPROVED' &&
        activity.additional_questions != null &&
        this.playerData.level && this.playerData.level.name === 'Carpintero' &&
        (
          (Array.isArray(activity.additional_questions) && activity.additional_questions.length > 0) ||
          (typeof activity.additional_questions === 'object' && Object.keys(activity.additional_questions).length > 0)
        )
      );

      if (hasApprovedItem) {
        listActivities.push(activity);
      }
    }


    if (listActivities.length === 0) {
      for (const item of items) {
        await this.acceptInvoice(item)
      }
    } else {
      const modal = await this.modalController.create({
        component: ModalAdditionalQuestionsPage,
        cssClass: 'additional-questions-modal',
        componentProps: {
          listActivities: listActivities
        }
      });

      await modal.present();

      const { data } = await modal.onWillDismiss();

      for (const item of items) {
        item.additional_answers = [data]
        await this.acceptInvoice(item)
      }
    }
  }

  markActivityChecked(activity) {
    activity.checked = !activity.checked
    if (activity.checked) {
      this.selectedActivities.push(activity)
    } else {
      this.selectedActivities = this.selectedActivities.filter(r => r.id != activity.id)
    }

    this.markAllActivities = this.selectedActivities.length === this.ia_activities.length;

    // use this to debug the this.selectedActivities array
    // console.log("selected activities mark activity", this.selectedActivities)
  }

  toggleAllActivities() {
    const is_checked = !this.markAllActivities
    for (let activity of this.ia_activities) {
      if (is_checked) {
        activity.checked = true
        this.selectedActivities = [...this.ia_activities]
      } else {
        activity.checked = false;
        this.selectedActivities = []
      }
    }

    // use this to debug the this.selectedActivities array
    // console.log("selected activities toggle", this.selectedActivities)
  }

  async openModalResume() {
    this.closeModal()
    const modal = await this.modalController.create({
        component: ModalIaResultsResumePage,
        cssClass: 'ia-results-resume-modal',
        componentProps: {
          ia_template: this.template
        }
      });

      await modal.present();
  }
}
